export const getItems = state => state.despVendas.items;

export default {
	getItems,
};
